import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center" data-testid="auth-loading">
        <Loader2 className="w-6 h-6 animate-spin text-blaze" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/entrar" state={{ from: location.pathname }} replace />;
  }
  return children;
}
